import {css} from 'emotion'
import { Colors } from '../core';

export const GalleryStyle = (open, transition) => css({
  position: 'relative',
  
  '.gallery': {
    '&__pictures': {
      margin: '0 -0.375rem',
    },
    '&__picture': {
      position: 'relative',
      width: 'calc(1/2 * 100%)',
      height: 180,
      overflow: 'hidden',
      padding: '0.375rem',
      cursor: 'pointer',
      opacity: 0.3,
      transition: 'opacity 300ms ease',

     '&.active': {
        opacity: 1
      },
      'img': {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
      },
      '@media (min-width: 1024px)': {
        width: 'calc(1/4 * 100%)',
      }
    },
    '&__focus': {
      position: 'relative',
      marginTop: '0.3125rem',
      display: 'inline-block',
      transition: `transform 400ms ease, visibility 0ms ${open ? 0 : 400 }ms`,
      transform: `scaleY(${open ? 1 : 0})`,
      transformOrigin: 'center top',
      visibility: open ? 'visible': 'hidden',
      fontSize: 0,

      'img': {
        width: 'auto',
        height: 'auto',
        maxHeight: 500,
        maxWidth: '100%',
        opacity: transition ? 1 : 0,
        transition: `opacity 300ms ease`,
        '@media (min-width: 1024px)': {
          maxHeight: 500,
          maxWidth: 'none',
        }
      },

      '&-legend': {
        textAlign: 'left',
        margin: '1rem 0',
        fontSize: '0.8125rem',
      },
    },
    '&__close': {
      position: 'absolute',
      top: '2rem',
      right: '2rem',
      width: 30,
      height: 30,
      zIndex: 2,
      background: 'transparent',
      border: 0,
      cursor: 'pointer',
      opacity: open ? 1 : 0,
      transition: `opacity 300ms ease ${open ? 400 : 0}ms`,

      '&:after, &:before':{
        content: "''",
        position: 'absolute',
        top: '50%',
        left: '50%',
        width: 24,
        height: 2,
        background: 'white',
      },

      '&:after': {
        transform: 'translate(-50%) rotate(-45deg)',
      },
      '&:before': {
        transform: 'translate(-50%) rotate(45deg)',
      }
    },
  }
})


// WEBPACK FOOTER //
// ./src/styles/components/gallery.js